<template>
    <DModal
        :show="showModal"
        :title="title"
        is-confirm
        is-big
        overflow-auto
        @confirm="confirmModal"
        @close="closeModal"
    >
        <DRow>
            <DCol md="12">
                <DCard class="pt-0">
                    <DCardBody class="overflow-hidden">
                        <pdf
                            v-for="i in numPages"
                            :key="i"
                            :src="pdfSource"
                            :page="i"
                        />
                    </DCardBody>
                </DCard>
            </DCol>
        </DRow>
    </DModal>
</template>

<script>
import pdf from 'vue3-pdf'

export default {
    name: 'DocumentPreSavePreview',
    components: {
        pdf
    },
    props: {
        title: {
            type: String,
            default: ''
        },
        showModal: {
            type: Boolean,
            default: false
        },
        pdfSource: {
            type: String,
            default: ''
        },
        numPages: {
            type: Number,
            default: 1
        }
    },
    emits: ['confirm', 'close'],
    methods: {
        confirmModal () {
            this.$emit('confirm')
        },
        closeModal () {
            this.$emit('close')
        }
    }
}
</script>

<style lang="scss" scoped>
.overflow-hidden {
    overflow: hidden !important;
}
</style>
